<h1 mat-dialog-title>Latest Changes</h1>
<div mat-dialog-content>
  <p>Ctrl key has updated from {{ data.lastVersion }} to {{ data.currentVersion }}. Please carefully read the changes below.</p>
  @if (!empty) {
    <p>Changes marked with [U] affect all users while [SA] affect site administrators.</p>
    <markdown [data]="latest"></markdown>
  } @else {
    <p>There are no recent changes that impact your use of Ctrl key!</p>
  }
</div>
<div mat-dialog-actions>
  <button matButton="outlined" (click)="close()" cdkFocusInitial>Dismiss</button>
</div>
